// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__31CiZ","footer":"ModalUpdate_footer__2mVhL"};